import React from 'react'
import { useRef, useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from './context/AuthContext';
import "./SignUp.css"
// import { Link } from 'react-router-dom/cjs/react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import "firebase/compat/firestore";
import "firebase/compat/auth";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { BsGoogle } from "react-icons/bs"
import { IoLogoGithub } from "react-icons/io"
import { FaFacebookF } from "react-icons/fa"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { provider, auth } from './Firebase/Firebase';
import { GithubAuthProvider } from 'firebase/auth';
import { FacebookAuthProvider } from 'firebase/auth';
import 'react-toastify/dist/ReactToastify.css';




function SignIn({ onHide }) {
    const emailRef = useRef()
    const passwordRef = useRef()
    const { signIn } = useAuth()
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    

    async function handleSubmit(e) {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            setValidated(true); // This will show validation errors on form fields
            return; // Exit the function if the form is not valid
        }

        // If the form is valid, continue with the sign-up process
        setValidated(false); // Reset the validation state

        try {
            setError('')
            setLoading(true)
            await signIn(emailRef.current.value, passwordRef.current.value);

            onHide();
          


        } catch {
            setError('Failed to sign in')
        }
        setLoading(false)


    }


    const handleGoogle = async () => {
        setError('');
        try {
            // Get the email from the provider's response
            const result = await auth.signInWithPopup(provider);
            const user = result.user;

            console.log("Signed in with Google:", user.displayName);

            setTimeout(() => {
                onHide();
            }, 100);
         
        } catch (error) {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log("Google sign-in error:", errorCode, errorMessage);

            if (errorCode === 'auth/account-exists-with-different-credential') {
                setError('An account already exists with the same email but different sign-in method.');
            } else {
                setError('Google sign-in failed');
            }
        }
    }


    const signInWithGithub = async () => {
        setError('');

        try {
            const result = await auth.signInWithPopup(new GithubAuthProvider());
            // The signed-in user info.
            const user = result.user;
            // This gives you a Github Access Token. You can use it to access the Github API.
            const credential = GithubAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;
            console.log(user, accessToken);
            setError('');
          
                setTimeout(() => {
                    onHide();
                }, 100);
           
        
        } catch (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            alert(errorMessage);
            console.log(errorCode, errorMessage);


        }
    }
    const signInWithFacebook = async () => {
        setError('');

        try {
            const result = await auth.signInWithPopup(new FacebookAuthProvider());
            // The signed-in user info.
            const user = result.user;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            const credential = FacebookAuthProvider.credentialFromResult(result);
            const accessToken = credential.accessToken;
            console.log(user, accessToken);
            setError('');

           
                setTimeout(() => {
                    onHide();
                }, 100);
          
            
       
        } catch (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode, errorMessage);
            setError('User already exists');
        }

    }



    return (
        <>
            <div className='contyBod'>
                <Card className='CardBod'>
                    <Card.Body>
                        <h2 className='text-center mb-4 header'>Sign In</h2>

                        {error && <Alert variant="danger">{error}</Alert>}

                        <Form noValidate validated={validated} onSubmit={handleSubmit}>

                            <Form.Group className="mb-3" controlId="formGroupLabel">
                                <FloatingLabel
                                    controlId="floatingInput1"
                                    label="Email Address"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="email" className='formInp' placeholder='Email Address'
                                        ref={emailRef}
                                        required />
                                </FloatingLabel>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupHeading">
                                <FloatingLabel
                                    controlId="floatingInput2"
                                    label="Password"
                                    className="mb-3 bg-transparent text-dark"
                                >
                                    <Form.Control type="password" className='formInp' placeholder='Password'
                                        ref={passwordRef}

                                        required />
                                </FloatingLabel>

                            </Form.Group>


                            {/* <Form.Text className=' already'>
                                <p className=' already'>Not yet a member?<Link to="/SignUp" className="link_item"> Register </Link></p>
                            </Form.Text> */}
                            <div className="W-100 d-flex  justify-content-center ">



                                <Button disabled={loading} type='submit' className='btn outl signInBtn ' >Sign In</Button>
                            </div>


                        </Form>
                        <div>
                            <div className=' already'>
                                <p>Or create sign in with</p>
                            </div>
                            <div className='butHold'>
                                <Row>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='button' className='btn SocialIn ' onClick={handleGoogle}><BsGoogle /> Google</Button>
                                    </Col>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='button' className='btn SocialIn  ' onClick={signInWithGithub}><IoLogoGithub /> Github</Button>
                                    </Col>
                                    <Col className='padi'>
                                        <Button disabled={loading} type='button' className='btn SocialIn  ' onClick={signInWithFacebook}><FaFacebookF /> Facebook</Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                    </Card.Body>
                </Card>

            </div>
        </>
    )
}

export default SignIn
